import { PropsWithChildren } from "react";

import { JSMOverlayTemplate } from "@/components/signup/layouts";

import { OnboardingContainerProps } from "../../../components";

export const ServCoOnboardingContainer = ({
    header,
    subheader,
    hideSubHeader,
    children,
    size = "lg",
    hideLogo = false
}: OnboardingContainerProps & PropsWithChildren & { hideLogo?: boolean }) => (
    <JSMOverlayTemplate
        header={header}
        subheader={hideSubHeader ? " " : subheader}
        size={size}
        hideLogo={hideLogo}
    >
        {children}
    </JSMOverlayTemplate>
);
